import React from 'react';
import PropTypes from 'prop-types';
import HighlightAndFilterItem from './HighlightAndFilterItem';

const HighlightAndFilterItems = ({
  items,
  handleRuleSelection,
  removeSelected,
}) => {
  const renderList = () =>
    items.map(item => (
      <HighlightAndFilterItem
        key={item.key}
        item={item}
        handleRuleSelection={selectedElementId =>
          handleRuleSelection(selectedElementId)
        }
        removeSelected={removeSelected}
      />
    ));

  return (
    <div className="highlight-filter-component">
      <ul
        className="vertical dropdown menu user-select-none"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

HighlightAndFilterItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  handleRuleSelection: PropTypes.func,
  removeSelected: PropTypes.func,
};

export default HighlightAndFilterItems;
